import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const OpenIconMUI = OpenInNewIcon;
